import React from 'react';
import Button from 'components/Button';
import Modal from 'components/modals/Modal';

export default function ModalCoachPending({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: () => void;
}) {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <div className="flex flex-col items-center justify-center p-8 text-left">
        <h1 className="typography-product-heading  text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          This coach is still setting up their schedule
        </h1>
        <p className="typography-product-body mt-4  text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          They will be available to coach soon, and we will let them know players are waiting.
        </p>
        <div className="mt-8 w-full">
          <Button variant="brand" size="lg" onClick={handleClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}
